module.exports = __webpack_public_path__ + "img/img50.6076239b.webp";